export default __webpack_public_path__ + "static/media/roadmap2.ee7060ac.png";